import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "product-details__container" }
const _hoisted_3 = ["title", "innerHTML"]
const _hoisted_4 = { class: "product-details__container" }
const _hoisted_5 = { class: "product-content-block product-content-block--text-block-left" }
const _hoisted_6 = { class: "product-content-block__wrapper" }
const _hoisted_7 = { class: "product-content-block__wrapper-text" }
const _hoisted_8 = { class: "product-content-block__wrapper-text-inner" }
const _hoisted_9 = ["innerHTML"]
const _hoisted_10 = ["innerHTML"]
const _hoisted_11 = { class: "product-content-block__button" }
const _hoisted_12 = { class: "product-content-block__button-inner" }
const _hoisted_13 = ["href", "innerHTML"]
const _hoisted_14 = { class: "product-content-block__images" }
const _hoisted_15 = { key: 0 }
const _hoisted_16 = { class: "product-details__container product-details__subs-part" }
const _hoisted_17 = { class: "product-details__headline product-details__headline--product-subscription" }
const _hoisted_18 = { class: "product-details__container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_image_element = _resolveComponent("image-element")!
  const _component_lazy_load = _resolveComponent("lazy-load")!
  const _component_product_content_block = _resolveComponent("product-content-block")!

  return (_ctx.productStore.productDetails.isSubscription)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("header", {
            class: "product-details__headline product-details__headline--product-subscription",
            title: _ctx.$t('ads.main.head.subscription.title'),
            innerHTML: _ctx.$t('ads.main.head.generic_subscription')
          }, null, 8 /* PROPS */, _hoisted_3)
        ]),
        _cache[4] || (_cache[4] = _createTextVNode()),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("h2", {
                    class: "product-content-block__headline headline headline--type_h2",
                    innerHTML: _ctx.$t('ads.subscription.headline')
                  }, null, 8 /* PROPS */, _hoisted_9),
                  _cache[0] || (_cache[0] = _createTextVNode()),
                  _createElementVNode("div", {
                    class: "product-content-block__description",
                    innerHTML: _ctx.$t('ads.subscription.text')
                  }, null, 8 /* PROPS */, _hoisted_10),
                  _cache[1] || (_cache[1] = _createTextVNode()),
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("div", _hoisted_12, [
                      _createElementVNode("a", {
                        class: "button button--text button--link-arrow product-content-block__button-link",
                        href: _ctx.$t('ads.subscription.link.href'),
                        innerHTML: _ctx.$t('ads.subscription.link.text')
                      }, null, 8 /* PROPS */, _hoisted_13)
                    ])
                  ])
                ])
              ]),
              _cache[2] || (_cache[2] = _createTextVNode()),
              _createVNode(_component_lazy_load, { class: "product-content-block__wrapper-image" }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_14, [
                    _createVNode(_component_image_element, {
                      src: [_ctx.fallbackImage],
                      alt: _ctx.$t('ads.main.head.generic_subscription'),
                      "img-class": "product-content-block__image product-content-block__image--auto-center"
                    }, null, 8 /* PROPS */, ["src", "alt"])
                  ])
                ]),
                _: 1 /* STABLE */
              })
            ])
          ])
        ]),
        _cache[5] || (_cache[5] = _createTextVNode()),
        (_ctx.productSubscription.displayName && _ctx.productSubscription.shortDescription)
          ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
              _createElementVNode("div", _hoisted_16, [
                _createElementVNode("header", _hoisted_17, _toDisplayString(_ctx.$t('ads.main.head.subscription', [_ctx.productStore.productDetails.product.description1, _ctx.productStore.productDetails.product.description3 ])), 1 /* TEXT */)
              ]),
              _cache[3] || (_cache[3] = _createTextVNode()),
              _createElementVNode("div", _hoisted_18, [
                _createVNode(_component_product_content_block, {
                  "show-carousel": _ctx.showCarousel,
                  "fallback-image": _ctx.fallbackImage,
                  class: "product-subscription",
                  "read-more-target-class": "product-details__headline--product-subscription",
                  headline: _ctx.productSubscription.displayName,
                  subline: _ctx.productSubscription.subtitle,
                  text: _ctx.productSubscription.shortDescription,
                  "link1-text": _ctx.productSubscription.linkText,
                  "link1-url": _ctx.productSubscription.linkUrl,
                  images: _ctx.productSubscription.images,
                  type: "subscription"
                }, null, 8 /* PROPS */, ["show-carousel", "fallback-image", "headline", "subline", "text", "link1-text", "link1-url", "images"])
              ])
            ]))
          : _createCommentVNode("v-if", true)
      ]))
    : _createCommentVNode("v-if", true)
}